import { Spin } from 'antd';
import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Dashboard from './dashboard';
import CompanyRole from './companyRole';
import FilerRole from './filerRole';
import withAdminLayout from '../../layout/withAdminLayout';

const NotFound = lazy(() => import('../../container/pages/404'));
const AuthorizedFilers = lazy(() => import('../../container/dashboard/AuthorizedFilers'));
const FormsPage = lazy(() => import('../../container/dashboard/formspage'))
// const SelectRole = lazy(() => import('../../container/profile/authentication/overview/SelectRole'));

const Admin = React.memo(() => {
  // const userRole = localStorage.getItem("user_role");

  const { pathname } = useLocation();
  // const auth = useAuth();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        {/* {userRole === 'company' && <Route path="/company/*" element={<CompanyRole />} />}
        {userRole === 'filer' && <Route path="/filer/*" element={<FilerRole />} />} */}
        <Route path="*" element={<Dashboard />} />
        <Route path="/admin" element={<Dashboard />} />
        <Route path="/company-dashboard" element={<Dashboard />} />
        <Route path="/filer-dashboard" element={<Dashboard />} />
        {/* <Route path="select-role" element={<SelectRole />} /> */}
        <Route path="authorized-filers/*" element={<AuthorizedFilers />} />
        <Route path="forms" element={<FormsPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Admin);
